<template lang="pug">
.content(:class="{ 'is-sortable': edit && sortable, 'is-deletable': deletable, 'is-restorable': content.deleted }")
    .fields
        .field(
            v-if="config.fields && config.fields.length"
            v-for="field in config.fields" :key="field.key"
            :class="[field.key, { edit, deleted: content.deleted }]"
        )
            reaction-input-field(
                :key="`${content.id}-${field.key}`"
                :section="section"
                :reaction="reaction"
                :content="content"
                :options="options"
                :config="field"
                :settings="config.settings"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :edit="edit"
            )
</template>

<script>
import ReactionInputField from './ReactionInputField'
import InputContent from '@/components/Page/Sections/Partials/InputContent'

export default {
    name: 'ReactionInputContent',
    extends: InputContent,
    props: {
        information: {
            type: Object,
            required: true
        },
        section: {
            type: Object,
            required: true
        },
        reaction: {
            type: Object,
            required: true
        },
    },
    components: {
        ReactionInputField
    },
}
</script>
